<!-- eslint-disable -->
<template lang="pug">
    .create-banner
        .create-banner__header
            | {{ $i18n.t('dashboard.dashboard_createBanner_header') }}
        .create-banner__body
            .create-banner__profiles
                .create-banner__button(
                    v-for="(route, profileType) in profileTypes"
                    v-if="isCreateAvailable(profileType)"
                    :key="profileType"
                )
                    cs-button(
                        color="blue",
                        pattern="primary-outline"
                        @click="$router.push({name: route, params: {type: profileType}})"
                        :disabled="blockAccessToCreateButton(profileType) || isTeacherBillingAndSchoolAccountStatusInactive")
                        | {{ createNewButton(profileType) }}
            divider(:margin="'10px auto'" :not-show-last-child="true")
            games-buttons(v-if="user.type !== 'admin' || user.isManagerOrSupport || user.isSuperadmin" )
</template>

<script>
    /*eslint-disable*/
    import GamesButtons from './GamesButtons.vue';
    import BillingBlockMixin from '../../../utils/user/BillingBlockMixin';


    export default {
        components: {GamesButtons},
        mixins: [BillingBlockMixin],
        data () {
            return {
                adminAvailableTypes: ['student', 'teacher', 'grade'],
                profileTypes: {
                    'admin': 'user:create',
                    'school': 'school:create',
                    'course': 'course:create',
                    'student': 'user:create',
                    'teacher': 'user:create',
                    'grade': 'grade:create',
                }
            }
        },
        methods: {
            createNewButton (profileType) {
                return this.$i18n.t('dashboard.dashboard_education_createNew' + _.capitalize(profileType));
            },
            blockAccessToCreateButton (profileType) {
                return profileType === 'teacher' ? false : this.areSchoolsBlocked;
            },
            isCreateAvailable (profileType) {
                if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                    return true
                }
                return this.adminAvailableTypes.includes(profileType);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .create-banner {
        padding: 30px 30px 20px 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .create-banner__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 5px;
    }

    .create-banner__body {
        font-size: 16px;
        line-height: 24px;
    }

    .create-banner__button {
        display: inline-flex;
        padding: 10px;
    }

    .create-banner__school {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }

    .school__balance {
        font-weight: 500;
    }

    .school__name, .school__button {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .create-banner__profiles {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -10px;
    }
</style>
